import React, { createContext, useContext, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { regionConfigs } from '../config/regions';

const RegionContext = createContext(null);

export const RegionProvider = ({ children }) => {
    const location = useLocation();

    // Extract region from path: /nz/* or /us/*
    const region = useMemo(() => {
        const pathSegments = location.pathname.split('/').filter(Boolean);
        const firstSegment = pathSegments[0]?.toLowerCase();

        if (firstSegment === 'nz') return 'nz';
        if (firstSegment === 'us') return 'us';
        return 'us'; // default to AlphaOmega
    }, [location.pathname]);

    const config = regionConfigs[region];

    const value = useMemo(
        () => ({ region, config }),
        [region, config]
    );

    return (
        <RegionContext.Provider value={value}>
            {children}
        </RegionContext.Provider>
    );
};

export const useRegion = () => {
    const context = useContext(RegionContext);
    if (!context) {
        throw new Error('useRegion must be used within RegionProvider');
    }
    return context;
};
